import { SocialPlatformButton } from 'components/SocialPlatformButton'
import { MouseEventHandler, TouchEventHandler, useRef, useState } from 'react'

import { TSvgIcon } from '@/types'

export const PlatformButton = ({
	id,
	name,
	Icon,
	isSelected,
	onClick,
}: {
	id: string
	name: string
	Icon: TSvgIcon
	isSelected: boolean
	onClick: () => void
}) => {
	const [touchMoved, setTouchMoved] = useState(false)
	const touchStartRef = useRef({ x: 0, y: 0 })
	const mouseStartRef = useRef({ x: 0, y: 0 })
	const mouseMovedRef = useRef(false)
	const touchHandledRef = useRef(false)

	// Touch Events (Mobile)
	const handleTouchStart: TouchEventHandler<HTMLButtonElement> = (event) => {
		const touch = event.touches?.[0]
		if (!touch) return

		setTouchMoved(false)
		touchHandledRef.current = false
		touchStartRef.current = { x: touch.clientX, y: touch.clientY }
	}

	const handleTouchMove: TouchEventHandler<HTMLButtonElement> = (event) => {
		const touch = event.touches?.[0]
		if (!touch) return

		const deltaX = Math.abs(touch.clientX - touchStartRef.current.x)
		const deltaY = Math.abs(touch.clientY - touchStartRef.current.y)

		if (deltaX > 10 || deltaY > 10) {
			setTouchMoved(true)
		}
	}

	const handleTouchEnd = () => {
		if (!touchMoved) {
			touchHandledRef.current = true
			onClick()
		}
	}

	// Mouse Events (Desktop)
	const handleMouseDown: MouseEventHandler<HTMLButtonElement> = (event) => {
		mouseMovedRef.current = false
		mouseStartRef.current = { x: event.clientX, y: event.clientY }
	}

	const handleMouseMove: MouseEventHandler<HTMLButtonElement> = (event) => {
		const deltaX = Math.abs(event.clientX - mouseStartRef.current.x)
		const deltaY = Math.abs(event.clientY - mouseStartRef.current.y)
		if (deltaX > 5 || deltaY > 5) {
			mouseMovedRef.current = true
		}
	}

	const handleMouseUp = () => {
		if (!mouseMovedRef.current && !touchHandledRef.current) {
			onClick()
		}
	}

	return (
		<SocialPlatformButton
			id={id}
			name={name}
			Icon={Icon}
			isSelected={isSelected}
			onTouchStart={handleTouchStart}
			onTouchMove={handleTouchMove}
			onTouchEnd={handleTouchEnd}
			onMouseDown={handleMouseDown}
			onMouseMove={handleMouseMove}
			onMouseUp={handleMouseUp}
			onClick={(event) => {
				// Prevents from submitting the form on click
				event.preventDefault()
			}}
		>
			<Icon />
		</SocialPlatformButton>
	)
}
